import { SkaiciuokleParamType } from "./SkaiciuokleParamType";

export const PARAM: { [index: string]: SkaiciuokleParamType } = {
  "2026": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 747,
        mma: 1153,
        maxPajamos: 2677.489796,
        npdBeta: 0.49,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1127
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1057
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 22.5,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.49,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2025": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: 2387.29,
        fixNpd: 747,
        mma: 1038,
        maxPajamos: 2562.489796,
        npdBeta: 0.49,
      },
      {
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 642,
        maxPajamos: 2864.222222,
        npdBeta: 0.18,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1127
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1057
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 22.5,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.43,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2024": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: 2167,
        fixNpd: 747,
        mma: 924,
        maxPajamos: 2418,
        npdBeta: 0.5,
      },
      {
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 642,
        maxPajamos: 2864.222222,
        npdBeta: 0.18,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1127
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1057
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 22.2,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.4,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2023": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: 1926,
        fixNpd: 625,
        mma: 840,
        maxPajamos: 2328.095238,
        npdBeta: 0.42,
      },
      {
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 642,
        maxPajamos: 2864.222222,
        npdBeta: 0.18,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 1005
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 935
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 22.2,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.4,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2022": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: 1704,
        fixNpd: 540,
        mma: 730,
        maxPajamos: 2318.235294,
        npdBeta: 0.34,
      },
      {
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 642,
        maxPajamos: 2864.222222,
        npdBeta: 0.18,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 870
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 810
      }]
    },
    // "2022": {
    //   gpm: {
    //     tarifas: 20,
    //     npdDuomenys: [{
    //       tipas: "standartinis",
    //       taikomaIki: 1678,
    //       fixNpd: 460,
    //       mma: 730,
    //       maxPajamos: 2499.230769,
    //       npdBeta: 0.26,
    //     },
    //     {
    //       tipas: "standartinis",
    //       taikomaIki: Number.POSITIVE_INFINITY,
    //       fixNpd: 400,
    //       mma: 642,
    //       maxPajamos: 2864.222222,
    //       npdBeta: 0.18,
    //     },
    //     {
    //       tipas: "npd0_25",
    //       taikomaIki: Number.POSITIVE_INFINITY,
    //       fixNpd: 740
    //     },
    //     {
    //       tipas: "npd30_55",
    //       taikomaIki: Number.POSITIVE_INFINITY,
    //       fixNpd: 690
    //     }]
    //   },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 22.2,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.54,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2021": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 642,
        maxPajamos: 2864.222222,
        npdBeta: 0.18,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 645
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 600
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 21.9,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.47,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2020": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 400,
        mma: 607,
        maxPajamos: 2712.263158,
        npdBeta: 0.19,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 645
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 600
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 21.6,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.4,
      III: 0.7,
      IV: 1.4,
    },
  },
  "2019": {
    gpm: {
      tarifas: 20,
      npdDuomenys: [{
        tipas: "standartinis",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 300,
        mma: 555,
        maxPajamos: 2555,
        npdBeta: 0.15,
      },
      {
        tipas: "npd0_25",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 353
      },
      {
        tipas: "npd30_55",
        taikomaIki: Number.POSITIVE_INFINITY,
        fixNpd: 308
      }]
    },
    darbuotojoTarifas: {
      nekaupia: 19.5,
      kaupiaPalaipsniui: 21.3,
      kaupia: 22.5,
    },
    sutartiesTipas: {
      neterminuota: 1.31,
      terminuota: 2.03,
    },
    draudejoTipas: {
      privatus: 0.32,
      biudzetine: 0,
      lietuvosBankas: 0,
      politinesPartijos: 0.16,
      profesinesSajungos: 0.16,
      religinesBendrijos: 0.16,
    },
    draudejoGrupe: {
      I: 0.14,
      II: 0.36,
      III: 0.7,
      IV: 1.4,
    },
  },
};
